<div class="modal-header">
  <h5 class="modal-title">{{ title | translate }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()">
  </button>
</div>
<div class="modal-body">
  <div *ngIf="warning != null" class="alert alert-warning d-flex align-items-center justify-content-center">
    <span [innerHTML]="warning | translate: {br: '<br>'}"></span>
  </div>
  <div *ngIf="!link" [innerHTML]="body | translate:{value: value, br: '<br>'}"></div>
  <div *ngIf="link">
    <span *ngIf="body != null && body.length > 0">{{body | translate}}</span>
    <br/>
    <a [href]="value | safeUrl" target="_blank" class="link">{{value}}</a>
  </div>
</div>
<div class="modal-footer">
  <ng-container *ngIf="showDismiss">
    <button type="button" class="btn btn-secondary" ngbAutofocus
            (click)="activeModal.dismiss()">{{ dismissLabel | translate }}</button>
    <button type="button" class="btn" [class]="'btn-' + btnStyle"
            (click)="activeModal.close()">{{ closeLabel | translate }}</button>
  </ng-container>
  <ng-container *ngIf="!showDismiss">
    <button type="button" class="btn" [class]="'btn-' + btnStyle" ngbAutofocus
            (click)="activeModal.close()">{{ closeLabel | translate }}</button>
  </ng-container>
</div>
